import React, { useState } from 'react';
import { Mutation } from '@apollo/client/react/components';
import { Delete, Cancel } from '@material-ui/icons';
import {
  IconButton,
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from '@material-ui/core';
import { DELETE_TITLE } from '../../../queries/titleContent';

interface IDeleteTitlesProps {
  selectedRows: Map<string, ITitle>;
  refetch: () => void;
}

const DeleteTitles: React.FC<IDeleteTitlesProps> = ({ selectedRows, refetch }) => {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [multiple, setMultiple] = useState(false);

  const handleCloseConfirmation = () => {
    setOpenConfirmation(false);
  };

  return (
    <Mutation
      mutation={DELETE_TITLE}
      update={async () => {
        await refetch();
      }}
    >
      {(deleteTitle: any) => (
        <div>
          <Tooltip title="Delete">
            <IconButton
              color="primary"
              aria-label="delete"
              onClick={(e) => {
                e.preventDefault();
                if (selectedRows.size > 1) {
                  setMultiple(true);
                } else {
                  setMultiple(false);
                }
                setOpenConfirmation(true);
              }}
            >
              <Delete />
            </IconButton>
          </Tooltip>
          <Dialog
            open={openConfirmation}
            onClose={handleCloseConfirmation}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {multiple
                  ? 'Do you really want to delete these Titles? This process cannot be undone.'
                  : 'Do you really want to delete this Title? This process cannot be undone.'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseConfirmation} color="default">
                <Cancel />
                {' '}
                Cancel
              </Button>
              <Button
                onClick={() => {
                  selectedRows.forEach(async (title) => {
                    await deleteTitle({ variables: { id: title.id } });
                  });
                  setOpenConfirmation(false);
                }}
                color="secondary"
                autoFocus
              >
                <Delete />
                {' '}
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </Mutation>
  );
};

export default DeleteTitles;
